import gql from 'graphql-tag';
import * as fragments from './fragments';

export const basketQuery = gql`
  query basket($id: ID!) {
    basket(id: $id) {
      ...BasketFragment
    }
  }
  ${fragments.basketFragment}
`;

export const campaignSearchQuery = gql`
  query campaignSearch($search_term: String!) {
    campaignSearch(search_term: $search_term) {
      id
      offer_name
      promotion_code
    }
  }
`;

export const deliveryTokensForUserQuery = gql`
  query ($user_id: ID!) {
    deliveryTokensForUser(user_id: $user_id) {
      id
      user_id
      vytal_user_id
      created_at
      ttl
    }
  }
`;

export const deliveryTokenQuery = gql`
  query ($delivery_token: ID!) {
    deliveryToken(id: $delivery_token) {
      id
      user_id
      vytal_user_id
      created_at
      ttl
    }
  }
`;

export const storeBasket = gql`
  query storeBasket($store_id: ID!, $campaigns: OverwriteCampaign) {
    storeBasket(store_id: $store_id, campaigns: $campaigns) {
      ...BasketFragment
    }
  }
  ${fragments.basketFragment}
`;

export const searchUsers = gql`
  query searchUsers($search_term: String) {
    searchUsers(search_term: $search_term) {
      id
      name
      email
    }
  }
`;

export const sessionQuery = gql`
  {
    session @client {
      user {
        ...UserFragment
      }
      store {
        ...StoreFragment
      }
      basket {
        ...BasketFragment
      }
      order {
        ...OrderFragment
      }
      pickup {
        time
        isInstantOrder
      }
    }
  }
  ${fragments.userFragment}
  ${fragments.storeFragment}
  ${fragments.basketFragment}
  ${fragments.orderFragment}
`;

// export const brandStores = gql`
//   query($brand_id: ID!, $geokey: String) {
//     brandStores(brand_id: $brand_id, geokey: $geokey) {
//       id
//       name
//       location_name
//       geo_hash
//       online
//       is_open
//       default_extras
//       has_inputfield
//       minimum_extras
//       maximum_extras
//       product_tags
//       opening_hours {
//         day
//         time
//       }
//       brand {
//         id
//         logo
//       }
//       distance {
//         distance
//         unit
//         raw
//       }
//     }
//   }
// `

export const adminSearchAutoCompleteQuery = gql`
  query ($search_term: String!, $limit: Int) {
    searchAutocomplete(
      search: $search_term
      filter: {
        admin_show_all: true
        include_locations: false
        include_geo_results: false
      }
      limit: $limit
      search_address: true
    ) {
      id
      name
      result_type
      stores {
        id
        brand_id
        name
        published
        coming_soon
        available_soon
        permanently_removed
        banner
        address {
          streetname
          streetno
          zip
          city
        }
      }
      brand {
        id
        name
        permanently_removed
        logo
      }
    }
  }
`;

export const storeIdSearchQuery = gql`
  query ($id: ID!) {
    store(id: $id) {
      id
      brand_id
      name
      published
      permanently_removed
      banner
      address {
        streetname
        streetno
        zip
        city
      }
      brand {
        id
        name
        permanently_removed
        logo
      }
    }
  }
`;

export const brandIdSearchQuery = gql`
  query ($id: ID!) {
    brand(id: $id) {
      id
      name
      permanently_removed
      logo
      stores {
        id
        brand_id
        name
        published
        permanently_removed
        banner
        address {
          streetname
          streetno
          zip
          city
        }
      }
    }
  }
`;

export const storesPaginatedSearchQuery = gql`
  query ($last_evaluated_key: ID, $filter: StoreFilterDb, $limit: Int) {
    paginatedStores(
      filter: $filter
      last_evaluated_key: $last_evaluated_key
      limit: $limit
    ) {
      last_evaluated_key
      stores {
        id
        name
        brand {
          id
          name
        }
        published
        permanently_removed
        contracted_date
        contract_end_date
        onboarded_date
        tier
        revenue_tier
        can_preorder
        can_deliver
        has_lieferando
        has_wolt
        has_ubereats
        has_mjam
        has_habgusta
        has_labonapp
        has_too_good_to_go
        has_rappi
        has_didi_food
        has_foodora
        acquired_at
        acquired_by
        country_code
        inkassokennzeichen
        onboarding_status
      }
    }
  }
`;

export const storeSearchQuery = gql`
  query ($admin_show_removed: Boolean) {
    stores(
      filter: { admin_show_all: true, admin_show_removed: $admin_show_removed }
    ) {
      id
      name
      banner
      external_vytal_id
      address {
        streetname
        streetno
        city
        zip
      }
      published
      permanently_removed
      brand_id
      contracted_date
      contract_end_date
      onboarded_date
      tier
      revenue_tier
      # brand {
      #   id
      #   name
      #   logo
      #   external_vytal_id
      #   permanently_removed
      # }
    }
    brands(admin_show_all: $admin_show_removed) {
      id
      name
      logo
      external_vytal_id
      permanently_removed
    }
  }
`;

export const adminCampaignQuery = gql`
  query campaign($id: ID!) {
    campaign(campaign_id: $id) {
      ...AdminCampaignFragment
    }
  }
  ${fragments.adminCampaignFragment}
`;

export const allNewsQuery = gql`
  query {
    news {
      ...ContentNewsFragment
    }
  }
  ${fragments.contentNewsFragment}
`;

export const selectedCitiesQuery = gql`
  query {
    selectedCities {
      id
      name
    }
  }
`;

export const adminUserOrderQuery = gql`
  query order($user_id: ID) {
    orders(user_id: $user_id) {
      id
      user_id
      pickup_time
      status
      total
      readable_id
      code_text
      store_total
      store {
        id
        name
      }
    }
  }
`;

export const adminUserQuery = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      name
      given_name
      family_name
      fraud_check
      email
      email_verified
      nickname
      role
      phone_number
      phone_number_verified
      used_brand_ids
      favorite_stores
      feature_next_handout_enabled
      feature_tap_to_borrow_enabled
      feature_tap_to_borrow_two_tap_flow
      tap_to_borrow_type
      stripe_connected_account_id
      store_id
      active_campaigns {
        id
        quantity_max
        promotion_code
        start_date
        end_date
        terms
        discount_percent
        user_quantity
        offer_name
        referral_name
      }
      account_type
      payment_details {
        paypal_id
        stripe_id
        default_source {
          id
          brand
          last4
          object
          fingerprint
          name
          type
        }
        sources {
          id
          brand
          last4
          object
          fingerprint
          name
          type
        }
      }
      accepted_agb
      accept_agb
      accept_privacy
      accept_push
      push_id
      accept_newsletter
      picture
      referral_code
      success_campaign {
        id
        offer_name
        referral_name
        show_success
      }
    }

    # Introspection query to get enum values
    tapToBorrowEnumInfo: __type(name: "TapToBorrowType") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const userPaymentQuery = gql`
  query user($id: ID!) {
    user(id: $id) {
      payment_details {
        paypal_id
        stripe_id
        default_source {
          id
          brand
          last4
          object
          fingerprint
          name
          type
        }
        sources {
          id
          brand
          last4
          object
          fingerprint
          name
          type
        }
      }
      vytal_credits
    }
  }
`;

export const userQuery = gql`
  query user($id: ID!) {
    user(id: $id) {
      ...UserFragment
    }
  }
  ${fragments.userFragment}
`;

export const userAppMetadataQuery = gql`
  query user($id: ID!) {
    user(id: $id) {
      app_metadata
    }
  }
`;

export const getUser = gql`
  query ($forceRefresh: Boolean, $sessionDeviceID: ID) {
    getUser(forceRefresh: $forceRefresh, session_device_id: $sessionDeviceID) {
      ...UserFragment
    }
  }
  ${fragments.userFragment}
`;

export const productCategories = gql`
  query ($id: ID!, $filter: ProductFilter) {
    productCategories(
      store_id: $id
      filter: $filter
      filter_options: { admin_show_all: true }
      get_all: true
    ) {
      id
      name
      icon
      published
      reusable_packaging
      products {
        ...ProductFragment
        in_stock
        contingent
      }
    }
  }
  ${fragments.productFragment}
`;
export const brandCategoryProductsByStore = gql`
  query ($store_id: ID!) {
    brandCategoryProductsByStore(store_id: $store_id) {
      store_id
      categories {
        id
        name
        product_ids
        products {
          id
          name
          extra_groups {
            extra_group_id
            name
            items {
              extra_id
              name
              price
              price_raw
            }
          }
          variants {
            id
            variant_id
            extra_groups {
              extra_group_id
              name
              items {
                extra_id
                name
                price
                price_raw
              }
            }
          }
        }
      }
    }
  }
`;

export const brandVatRatesByStore = gql`
  query ($store_id: ID!) {
    brandVatRatesByStore(store_id: $store_id)
  }
`;

export const currencyOfStoreQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      currency
    }
  }
`;

export const storeQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      ...StoreFragment
    }
  }
  ${fragments.storeFragment}
`;

export const storeBannerQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      id
      banner
    }
  }
`;

export const storeImagesQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      id
      images {
        created_at
        source
        url
        origin_url
        original_url
      }
    }
  }
`;

export const allStoreTypesQuery = gql`
  {
    __type(name: "StoreType") {
      enumValues {
        name
      }
    }
  }
`;

export const allFoodCategoriesQuery = gql`
  {
    __type(name: "FoodCategory") {
      enumValues {
        name
      }
    }
  }
`;

export const allBillingFrequenciesQuery = gql`
  {
    __type(name: "BillingFrequency") {
      enumValues {
        name
      }
    }
  }
`;

export const allCustomInvoiceItems = gql`
  {
    __type(name: "CustomInvoiceItemType") {
      enumValues {
        name
      }
    }
  }
`;

export const allUserCountriesQuery = gql`
  {
    __type(name: "UserCountry") {
      enumValues {
        name
      }
    }
  }
`;

export const allStoreTiersQuery = gql`
  {
    __type(name: "StoreTier") {
      enumValues {
        name
      }
    }
  }
`;

export const integrationOptionsQuery = gql`
  {
    integrationOptions {
      api_name
      name
    }
  }
`;

export const creditToPartnerOptionsQuery = gql`
  {
    creditToPartnerOptions {
      api_name
      name
    }
  }
`;

export const storePaymentDetailsQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      id
      name
      payment_details {
        id
        stripe_id
        default_source {
          ...StripeSourceFragment
        }
        sources {
          ...StripeSourceFragment
        }
      }
    }
  }
  ${fragments.StripeSourceFragment}
`;

export const adminStoreQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      ...StoreFragmentWithCategories
    }
  }
  ${fragments.storeFragmentWithCategories}
`;

export const adminBrandQuery = gql`
  query brand($id: ID!) {
    brand(id: $id) {
      ...BrandAdminFragment
    }
  }
  ${fragments.brandAdminFragment}
`;

export const adminInfoStoreQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      ...StoreAdminFragment
    }
  }
  ${fragments.storeAdminFragment}
`;

export const vendingMachineQuery = gql`
  query vendingMachine($id: ID!) {
    vendingMachine(id: $id) {
      ...VendingMachineFragment
    }
  }
  ${fragments.vendingMachineFragment}
`;

export const adminMinimalStoreQuery = gql`
  query store($store_id: ID!, $brand_id: ID!) {
    store(id: $store_id) {
      id
      external_vytal_id
      permanently_removed
      name
      banner
      published
      contracted_date
      contract_end_date
      onboarded_date
      acquired_by
      acquired_at
      tier
      revenue_tier
      type
      service_package_type
      service_package_start_date
      free_checkout_segment
      sustainability_reports_enabled
      invoice_yearly
      inkassokennzeichen
      onboarding_status
      country_code
      currency
      removal_reason
    }
    brand(id: $brand_id) {
      id
      external_vytal_id
      permanently_removed
      name
    }
  }
`;

export const adminBrandStoresQuery = gql`
  query store($brand_id: ID!) {
    brandStores(brand_id: $brand_id, admin_show_all: true) {
      id
      external_vytal_id
      permanently_removed
      name
      banner
      published
      contracted_date
      contract_end_date
      onboarded_date
      address {
        streetname
        streetno
        city
        zip
      }
    }
  }
`;

export const adminInfoStoreWithContactsQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      id
      name
      type
      contacts {
        id
        name
        salutation
        link
        first_name
        last_name
        email
        secondary_email
        title
        phone
        mobile
        language
        roles
        contact_departments
      }
    }
  }
`;

export const storesWithContactsQuery = gql`
  query stores($store_ids: [ID]) {
    stores(store_ids: $store_ids) {
      id
      name
      external_vytal_id
      region
      type
      delivery_address {
        company
        first_name
        last_name
        streetname
        streetno
        zip
        city
        additional_info
        email
        phone_number
      }
      address {
        streetname
        streetno
        zip
        city
      }
      country_code
      contacts {
        id
        name
        salutation
        link
        first_name
        last_name
        email
        title
        phone
      }
    }
  }
`;

export const adminSuperAdminInfoStoreQuery = gql`
  query store($id: ID!) {
    store(id: $id) {
      ...StoreDeliveryAdminFragment
    }
  }
  ${fragments.storeDeliveryAdminFragment}
`;

export const getInvoiceDataQuery = gql`
  query ($store_id: ID!, $year: Int!, $month: Int!) {
    getInvoiceData(store_id: $store_id, year: $year, month: $month) {
      total_platform_fee
      monthly_fee
      custom_items_total
      tax_fee
      total_minus_taxes
      transaction_cost_total
      would_generate_invoice
      onboarding_fee_vytal
      store_cards_sold_total
      invoice_xml
    }
  }
`;

export const getUsedPartnerCreditsQuery = gql`
  query ($store_id: ID!) {
    getUsedPartnerCredits(store_id: $store_id)
    store(id: $store_id) {
      id
      partner_credits
    }
  }
`;

export const getPartnerStoreInvoicesQuery = gql`
  query ($store_id: ID!) {
    getPartnerStoreInvoices(store_id: $store_id) {
      id
      label
      title
      store_id
      note
      url
      invoice_number
      status
      parsed_amount
      parsed_payment_direction
      total_net
      total_gross
      hidden
      date
      admin_info {
        id
        status
        title
        label
        generated_at
        send_processed_at
        send_at
        send_status
        send_error
        send_emails_used
        send_delivery_id
        send_delivery_link
        charged_at
        charged_amount
        charged_currency
        charged_transaction_id
        charged_charge_id
      }
      account_ledger {
        id
        booking_date
        credit_amount
        debit_amount
        invoice_reference
        statement_descriptor
      }
    }
  }
`;

export const getPartnerStoreNonLinkedAccountLedgersQuery = gql`
  query ($store_id: ID!) {
    getPartnerStoreNonLinkedAccountLedgers(store_id: $store_id) {
      id
      posting_number
      booking_date
      debitor_account_number
      statement_descriptor
      invoice_reference
      debit_amount
      credit_amount
      batch_number
      cost_center_1
      cost_center_2
      comment
      hidden_at
      hidden_by
      created_at
      updated_at
    }
  }
`;

export const getAccountLedgersForStoreQuery = gql`
  query ($store_id: ID!) {
    getAccountLedgersForStore(store_id: $store_id) {
      id
      posting_number
      booking_date
      debitor_account_number
      statement_descriptor
      invoice_reference
      debit_amount
      credit_amount
      batch_number
      cost_center_1
      cost_center_2
      billomat_invoice_id
      comment
      hidden_at
      hidden_by
      created_at
      updated_at
    }
  }
`;

export const storeListQuery = gql`
  query stores($geokey: String) {
    stores(geokey: $geokey) {
      ...StoreFragment
    }
  }
  ${fragments.storeFragment}
`;

export const activeOrderQuery = gql`
  query order($id: ID!) {
    order(id: $id) {
      ...OrderFragment
    }
  }
  ${fragments.orderFragment}
`;

export const partnerSelfSignupQuery = gql`
  query partnerSelfSignup($id: ID!) {
    partnerSelfSignup(id: $id) {
      id
      created_at
      panda_doc_id
      id
      created_at
      signed_at
      panda_doc_id
      company_name
      company_type
      email
      phone
      package
      first_name
      last_name
      address {
        street
        zipcode
        city
        country
      }
      billing_address {
        street
        zipcode
        city
        country
      }
      wanted_container_ids
      iban
      iban_name
      bic
      vat
    }
  }
`;

export const singleOrderQuery = gql`
  query order($order_id: ID!) {
    order(id: $order_id) {
      id
      type
      readable_id
      store_id
      user_id
      basket_id
      transaction_id
      payment_method
      code_text
      item_count
      containers {
        id
        name
      }
      total
      item_total
      platform_fee
      delivery_fee
      discount_amount
      discount_by_vytal_credits
      transfer_amount
      commission_rate
      user {
        id
        email
        name
        external_id
      }
      delivery_address {
        given_name
        family_name
        streetname
        streetno
        zip
        city
        phone_number
        additional_info
        description
        id
        type
        description
        lonlat {
          longitude
          latitude
        }
      }
      status_history {
        status
        updated_at
      }
      vat_total {
        vat_rate
        vat_amount
        total_amount
      }
      store_total
      terminal_total
      store_vat_total {
        vat_rate
        vat_amount
        total_amount
      }
      platform_fee
      status
      stripe_charge_id
      pickup_time
      type
      pickedup_time
      created_at
      updated_at
      items {
        id
        name
        price
        base_price
        quantity
        product_id
        variant_id
        extras {
          extra_id
          name
          price
        }
      }
      campaign {
        id
        offer_name
        promotion_code
      }
      platform_fee_campaign_id
      cutlery
      eat_in
      bell_status
      is_test_order
      store_discount_amount
      user {
        id
        email
        given_name
        family_name
        name
      }
      store {
        name
        id
      }
      user_rating
      external_id
      currency
      vending_machine {
        id
        name
      }
    }
  }
`;

export const partnerSelfSignupConfigsQuery = gql`
  query {
    getPartnerSelfSignUpConfigs {
      ...PartnerSelfSignupConfigFragment
    }
  }
  ${fragments.partnerSelfSignupConfigFragment}
`;

export const allCitiesQuery = gql`
  query {
    locations(filter: { only_cities: true }) {
      id
      name
      store_count
    }
  }
`;

export const allStoresQuery = gql`
  query {
    stores(filter: { admin_show_all: true }) {
      id
      city_id
      name
      external_vytal_id
      region
      brand {
        external_vytal_id
      }
      online
      published
      heartbeat
      can_preorder
      can_deliver
      always_online
    }
  }
`;

export const storesWithAssetsQuery = gql`
  query ($include_phones: Boolean, $include_return_boxes: Boolean) {
    storesWithAssets(
      filter: {
        include_phones: $include_phones
        include_return_boxes: $include_return_boxes
      }
    ) {
      id
      external_vytal_id
      name
      published
      permanently_removed
      brand {
        id
        external_vytal_id
      }
      phones {
        id
        type
        sim_provided
        sim_card_number
        phone_number
        monthly_charge
        pin
        serial_number
        description
      }
      return_boxes {
        id
        type
        location
        monthly_charge
        serviced
      }
      currency
    }
  }
`;

export const shortOrdersQuery = gql`
  query orders(
    $store_id: ID!
    $timespan_from: String!
    $timespan_to: String
    $include_external: Boolean
  ) {
    orders(
      store_id: $store_id
      timespan: { from: $timespan_from, to: $timespan_to }
      sort_by: DESC
      include_external: $include_external
    ) {
      id
      type
      user_id
      pickup_time
      status
      total
      readable_id
      code_text
      store_total
      external_id
      user {
        id
        external_id
        email
        given_name
        family_name
        name
      }
      store {
        name
        currency
      }
    }
    store(id: $store_id) {
      id
      currency
    }
  }
`;

export const ordersForUserQuery = gql`
  query orders($user_id: ID!, $timespan_from: String!) {
    orders(
      user_id: $user_id
      timespan: { from: $timespan_from }
      sort_by: DESC
    ) {
      id
      type
      user_id
      pickup_time
      status
      total
      readable_id
      code_text
      store_total
      store {
        name
        external_vytal_id
        brand {
          name
          external_vytal_id
        }
      }
    }
  }
`;

// export const orderOverviewQuery = gql`
//   query orders($user_id: ID!) {
//     orders( user_id: $user_id, sort_by: DESC) {
//       ...OrderFragment
//     }
//   }
//   ${fragments.orderFragment}
// `

// export const nearestStores = gql`
//   query nearestStores( $geokey: String!, $proximity: Int!, $filter: StoreFilter ) {
//     nearestStores(geokey: $geokey, proximity: $proximity, filter: $filter) {
//       ...StoreFragment
//     }
//   }
//   ${fragments.storeFragment}
// `

// export const nearestGroupedStores = gql`
//   query nearestGroupedStores($geokey: String!, $proximity: Int!, $filter: StoreFilter) {
//     nearestGroupedStores(geokey: $geokey, proximity: $proximity, filter: $filter) {
//       store {
//         ...StoreCardFragment
//       }
//       close_stores {
//         ...StoreCardFragment
//       }
//     }
//   }
//   ${fragments.storeCardFragment}
// `

// export const locationsQuery = gql`
//   query locations {
//     locations {
//       ...LocationFragment
//     }
//   }
//   ${fragments.locationFragment}
// `

// export const locationStores = gql`
//   query locationStores($location_id: ID!, $geokey: String, $filter: StoreFilter) {
//     locationStores(location_id: $location_id, geokey: $geokey, filter: $filter) {
//       stores {
//         ...StoreFragment
//       }
//       near_stores {
//         ...StoreFragment
//       }
//     }
//   }
//   ${fragments.storeFragment}
// `

// export const locationGroupedStores = gql`
//   query locationGroupedStores($location_id: ID!, $geokey: String, $filter: StoreFilter) {
//     locationGroupedStores(location_id: $location_id, geokey: $geokey, filter: $filter) {
//       stores {
//         store {
//           ...StoreCardFragment
//         }
//         close_stores {
//           ...StoreCardFragment
//         }
//       }
//       near_stores {
//         store {
//           ...StoreCardFragment
//         }
//         close_stores {
//           ...StoreCardFragment
//         }
//       }
//     }
//   }
//   ${fragments.storeCardFragment}
// `

// export const checkOTT = gql`
//   query checkOTTPayment($token: ID!) {
//     checkPaymentToken(token: $token) {
//       status
//       order_id
//     }
//   }`

// export const checkEmail = gql`
//   query checkEmail( $email: String! ) {
//     checkEmail(email: $email)
//   }
// `

// export const clearCache = gql`
//   query { brands { id } }
// `
